







































import { Component, Vue, Prop, Emit} from 'vue-property-decorator';
import licenses from '@/licenses.json';
import {globalStore} from "@/vue-global";
import {strings} from "@/strings";


@Component
export default class Licenses extends Vue {
  // value is licenseDialog to close
  @Prop() public value!: boolean;
  @Emit() public input(value: string) {}

  private licenses = licenses;

  // for language support
  private get strings() {
    return strings(globalStore.language);
  }

  private removeLibVersion(libName: string): string {
    const idx = libName.lastIndexOf('@');
    if (idx === -1) {
      return libName;
    } else {
      return libName.substring(0, idx);
    }
  }
}
